export default "__VITE_ASSET__CCOhv_YD__"